import { Routes } from '@angular/router';

export const helproutes: Routes = [
  { path: 'videotutorial', loadChildren: () => import('./videotutorial/videotutorial.module').then(m => m.VideotutorialModule), data: { animation: 'videotutorial', roles: 'ADMINISTRADOR,INTERNOS,INTERNO_NO_CONTABLE,MANAGER,EMPLEADO' } },
  { path: 'faq', loadChildren: () => import('./faqs/faqs.module').then(m => m.FaqsModule), data: { animation: 'faq', roles: 'ADMINISTRADOR,INTERNOS,INTERNO_NO_CONTABLE,MANAGER,EMPLEADO' } },
  { path: 'team', loadChildren: () => import('./team/team.module').then(m => m.TeamModule), data: { animation: 'team', roles: 'ADMINISTRADOR,INTERNOS,INTERNO_NO_CONTABLE,MANAGER,EMPLEADO' } }
]
